import { render } from "./App.vue?vue&type=template&id=3b1839f9"
const script = {}

import exportComponent from "/home/dan/Desktop/siftr/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__